import { render, staticRenderFns } from "./Historico.vue?vue&type=template&id=fc9f4b2c&scoped=true"
import script from "./Historico.vue?vue&type=script&lang=ts"
export * from "./Historico.vue?vue&type=script&lang=ts"
import style0 from "./Historico.vue?vue&type=style&index=0&id=fc9f4b2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9f4b2c",
  null
  
)

export default component.exports